<header>
  <div class="ce_header_desktop fixed-top" style="">
    <div class="container">
      <div class="ce_page_header">
        <a
          routerLink="/"
          class="logo"
          >&nbsp;</a
        >
      </div>
    </div>
  </div>
  <div class="ce_header_mobile fixed-top" style="">
    <dfn class="header_mobile_overlay"></dfn>
    <div class="fixedBar">
      <a
        routerLink="/"
        class="logo"
        >&nbsp;</a
      >
    </div>
  </div>
</header>
